import React, { useContext, useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import "chart.js/auto";
import { DataContext } from "../data/DataContext";
const LeftPanel = () => {
  const { data } = useContext(DataContext);
  const [genderData, setGenderData] = useState([0, 0, 0]);
  const [detectionResults, setDetectionResults] = useState([0, 0]);
  const [totalScreenings, setTotalScreenings] = useState(0);
  const LOADING_GIF_URL = "/loader3.gif";

  useEffect(() => {
    setGenderData(Object.values(data.data?.gender_stats));
    setDetectionResults([
      data.data?.total_positive_cases * 10,
      data.data?.total_negative_cases * 10,
    ]);
    setTotalScreenings(data.data?.total_screenings);
  }, [data]);
  const totalScreeningsData = {
    labels: ["Others", "Male", "Female"],
    datasets: [
      {
        label: "Screenings by Gender",
        data: genderData,
        backgroundColor: ["#96c73f", "#96c73f", "#96c73f"],
      },
    ],
  };

  const detectionResultsData = {
    labels: ["Positive Images", "Negative Images"],
    datasets: [
      {
        data: detectionResults,
        backgroundColor: ["#E63946", "#96C73F"],
      },
    ],
  };

  if (!data) {
    return (
      <img
        src={LOADING_GIF_URL}
        alt="Loading..."
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100px", // Adjust size if needed
          height: "100px",
          objectFit: "contain",
        }}
      />
    );
  }
  return (
    <div
      style={{
        width: "350px",
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        marginBottom: "1rem", // Prevents leaking
      }}
    >
      {/* Total Screenings */}
      <div
        style={{
          backgroundColor: "#1B1B38",
          color: "#fff",
          padding: "1rem",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ marginTop: 0 }}>Total Oral Images</h2>
        <h3 style={{ fontSize: "2rem", textAlign: "center" }}>
          {(totalScreenings * 10).toLocaleString("en-IN")}
        </h3>
        <Bar data={totalScreeningsData} />
      </div>

      {/* Detection Results */}
      <div
        style={{
          backgroundColor: "#1B1B38",
          color: "#fff",
          padding: "1rem",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ marginTop: 0 }}>Detection Results</h2>
        <div>
          <div style={{ textAlign: "center" }}>
            <p
              style={{
                fontSize: "1.8rem",
                color: "#ff4347",
                fontWeight: "bolder",
                margin: 0,
              }}
            >
              {detectionResults[0]}
            </p>
            <p style={{ fontSize: "1rem", color: "#fff", margin: "0.5rem 0" }}>
              Positive Images
            </p>
          </div>
        </div>

        <div style={{ width: "100%", height: 200 }}>
          <Pie
            data={detectionResultsData}
            options={{
              maintainAspectRatio: false,
            }}
            height={150}
          />
        </div>
      </div>
    </div>
  );
};

export default LeftPanel;
